//#region src/housekeeping/patchBoardRoom.ts
var e = (e, t) => !e || !e.rooms.some((e) => e.unit_id === t.unit_id) ? e : {
	...e,
	rooms: e.rooms.map((e) => e.unit_id === t.unit_id ? {
		...e,
		status: t.status,
		hk: t.hk
	} : e)
};
//#endregion
export { e as patchBoardRoom };
